import Context from './context';

export class UserobjController {
    constructor() {}
    public async Set(
        ctx: Context,
        userobj: {
            resType: string;
            resId: string;
            data: string;
            attr?: {[key: string]: string};
        },
    ): Promise<{error: any}> {
        const resType = userobj.resType;
        const resId = userobj.resId;
        const data = userobj.data;
        const attr = userobj.attr;
        const rsp = await ctx.conn.Call('/v1/sdk/userobj/set', {
            resType,
            resId,
            data,
            attr,
        });
        if (rsp && rsp.code === 0) {
            return {error: null};
        }
        return {error: JSON.stringify(rsp)};
    }
}
